


























































































import { UserApi,yun ,Area} from '@/http';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class permissionsDialog extends Vue {
    public dialogVisible: boolean = false;
    public dataDialogVisible: boolean = false;
    public form = {};
    public status: number = 1;
    public checkList = [];
    public strictly: boolean = true;
    public loading: boolean = false;
    public activeName = 'first';

    @Prop({ default: [] })
    treeData;

    public operatePermissions = [
        {
            id: 'uData',
            realName: '客户/基地名称',
            userList: [],
        },
    ];
    public operatePermissions1 = [
        {
            id: 'area',
            type: 'all',
            realName: '收货地',
            children: [],
        },
    ];
    public permissionIdsArr: any = [];
    /** 树默认不展开 */
    public defaultExpand = false;
    public defaultExpand1 = false;
    public defaultExpand2 = false;
    /** 是否展开 */
    public isExpand: boolean = false;
    public isExpand1: boolean = false;
    public isExpand2: boolean = false;
    public $refs: {
        vtree: HTMLFormElement;
        vtree1: HTMLFormElement;
        vtree2: HTMLFormElement;
    };
    /** 选中的权限 */
    public permissionIds:any = '';
    //是否管理员，权限是否为空
    public isShowAd: any;
    created() {
        this.isShowAd = sessionStorage.getItem('isShowAd') ? sessionStorage.getItem('isShowAd') : localStorage.getItem('isShowAd');
        this.webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
    }
    monted() {}
    //打开功能权限弹框
    public pid: string = '';
    public webMenus: any;
    public ownPermissions: any;
    public dataPermissions: any;
    //登录用户id
    public loginUserId = '';
    handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == '1') {
        }
    }
    public open(id) {
        this.loginUserId = JSON.parse(
            sessionStorage.getItem('id') ? sessionStorage.getItem('id') : JSON.parse(localStorage.getItem('mlssloginAd')).id
        );
        this.pid = id;
        this.defaultExpand = false;
        this.isExpand = false;
        this.loading = true;
        UserApi.GetUserDetail(this.pid)
            .then((res) => {
                if (this.isShowAd && this.pid == this.loginUserId) {
                    this.ownPermissions = this.webMenus;
                } else {
                    this.ownPermissions = res.webMenus;
                }
                this.dialogVisible = true;
                this.checked = this.ownPermissions ? this.ownPermissions.split(',') : [];
                this.permissionIdsArr = this.ownPermissions ? this.ownPermissions.split(',') : [];
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    //打开数据权限弹框
    public primaryDeptId: string = '';
    public isAdmin: boolean = false;
    public adminId: string = '';
    public did: string = '';
    public async operateOpen(id) {
        this.activeName = 'first'
        this.loading = true;
        this.defaultExpand1 = false;
        this.defaultExpand2 = false;

        this.isExpand1 = false;
        this.isExpand2 = false;
        this.did = id;
        this.permissionIdsArr = [];
        this.dataChecked = [];
        this.dataChecked1 = [];
        let res = await yun.getArrivalAdrDataPermissionList({id: this.did})
        res.items.forEach(datad=> {
            this.dataChecked1.push(datad)
        })
        UserApi.GetUserDetail(this.did)
            .then((res) => {
                this.primaryDeptId = res.primaryDeptId ? res.primaryDeptId : null;
                this.isAdmin = res.isAdmin;
                if (res.isAdmin) {
                    this.adminId = res.id;
                }
                this.dataPermissions = res.senderDataPermissions;
                this.userDepartmentData().then(async() => {
                    let resdd = await yun.getSenderDataPermissionList({id: this.did})
                    console.log('resdd',resdd)
                    this.dataDialogVisible = true;
                    if (resdd.items) {
                        resdd.items.map(dd => {
                            this.dataChecked.push(dd)
                        })
                    }
                    // this.dataChecked = resdd.items
                    this.permissionIdsArr = res.senderDataPermissions;
                    this.loading = false;
                });
                // if (res.dataPermissions) {
                // } else {
                //     this.operatePermissions[0].userList.forEach((e) => {
                //         this.dataChecked.push(String(e.id));
                //         this.permissionIdsArr.push(String(e.id));
                //     });
                //     this.dataDialogVisible = true;
                // }
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    //获取用户所在部门下的所有用户
    public async userDepartmentData() {
        let result = await yun.ShipperGetList({
            isEditPermission: true,
            shipperName: '',
            count: -1,
        });
        this.operatePermissions[0].userList = [];
        result.forEach((e) => {
            let obj = { id: e.id, realName: e.customerBaseName };
            this.operatePermissions[0].userList.push(obj);
        });
        let area = await Area.area();
        this.operatePermissions1[0].children = [];
        area.data.forEach(async (e) => {
            let obj = { id: e.value,type:'area', realName: e.text,children:[] };
            // let city = await Area.city(e.value);
            // obj.children = []
            // city.data.map(async e1 => {
            //     let obj1 = { id: e1.value, realName: e1.text,children:[] };
            //     obj1.children = []
            //     let County = await Area.county(e1.value);
            //     city.data.map(async e2 => {
            //         let obj2 = {id: e2.value, realName: e2.text,children:[]};
            //         obj1.children.push(obj2)
            //     })
            //     obj.children.push(obj1)
            // })
            this.operatePermissions1[0].children.push(obj);
        });
        console.log('area', this.operatePermissions1)
        // let res = await yun.getArrivalAdrDataPermissionList({})
        // console.log('this.operatePermissions[0].userLista==========>', JSON.stringify(this.operatePermissions[0].userList.length));
    }
    /** 全部展开 */
    public setCheckedNodes() {
        this.defaultExpand = true; //展开所有节点
        this.isExpand = true;
        for (var i = 0; i < this.$refs['vtree'].store._getAllNodes().length; i++) {
            this.$refs['vtree'].store._getAllNodes()[i].expanded = this.defaultExpand;
        }
    }

    /** 全部折叠 */
    public setCheckedKeys() {
        this.defaultExpand = false;
        this.isExpand = false;
        for (var i = 0; i < this.$refs['vtree'].store._getAllNodes().length; i++) {
            this.$refs['vtree'].store._getAllNodes()[i].expanded = this.defaultExpand;
        }
    }
    /** 全部展开 */
    public setDataCheckedNodes() {
        this.defaultExpand1 = true; //展开所有节点
        this.isExpand1 = true;
        for (var i = 0; i < this.$refs['vtree1'].store._getAllNodes().length; i++) {
            this.$refs['vtree1'].store._getAllNodes()[i].expanded = this.defaultExpand1;
        }
    }

    /** 全部折叠 */
    public setDataCheckedKeys() {
        this.defaultExpand1 = false;
        this.isExpand1 = false;
        for (var i = 0; i < this.$refs['vtree1'].store._getAllNodes().length; i++) {
            this.$refs['vtree1'].store._getAllNodes()[i].expanded = this.defaultExpand1;
        }
    }
    /** 全部展开 */
    public setDataCheckedNodes1() {
        this.defaultExpand2 = true; //展开所有节点
        this.isExpand2 = true;
        for (var i = 0; i < this.$refs['vtree2'].store._getAllNodes().length; i++) {
            this.$refs['vtree2'].store._getAllNodes()[i].expanded = this.defaultExpand2;
        }
    }

    /** 全部折叠 */
    public setDataCheckedKeys1() {
        this.defaultExpand2 = false;
        this.isExpand2 = false;
        for (var i = 0; i < this.$refs['vtree2'].store._getAllNodes().length; i++) {
            this.$refs['vtree2'].store._getAllNodes()[i].expanded = this.defaultExpand2;
        }
    }


    /**数据权限：配置选项 */
    public defaultDataProps = {
        label: 'realName',
        children: 'userList',
    };
    /**数据权限：配置选项 */
    public defaultDataProps1 = {
        label: 'realName',
        children: 'children',
    };
    /** 数据权限选中 */
    public isChecked = false;
    async handleNodeClick(data) {
        let canflash = false
        let xxs = []
        let county = null
        const loading = this.$loading({
            lock: true,
            text: 'Loading...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
        });
        if (data.type == 'area' && data.children.length == 0) {
            canflash = true
            let res = await yun.getArrivalAdrDataPermissionList({province:data.id,id: this.did})
            res.items.map(dd=> {
                this.dataChecked1.push(dd)
                xxs.push(dd)
            })
            console.log('dele',this.dataChecked1.findIndex(item => item === data.id))
            if (this.dataChecked1.findIndex(item => item === data.id)>=0) {
                this.dataChecked1.splice(this.dataChecked1.findIndex(item => item === data.id), 1)
            }
            let City = await Area.city(data.id);
            let arr = []
            City.data.map(e1=> {
                let obj1 = { id: e1.value, type: 'city',realName: e1.text,label: e1.text, children:[] };
                arr.push(obj1)
            })
            data.children = arr
        }
        if (data.type == 'city' && data.children.length == 0) {
            canflash = true
            let res = await yun.getArrivalAdrDataPermissionList({city:data.id,id: this.did})
            res.items.map(dd=> {
                xxs.push(dd)
                this.dataChecked1.push(dd)
            })
            console.log('dele',this.dataChecked1.findIndex(item => item === data.id))
            if (this.dataChecked1.findIndex(item => item === data.id)>0) {
                this.dataChecked1.splice(this.dataChecked1.findIndex(item => item === data.id), 1)
            }
            county = await Area.county(data.id);
            let arr = []
            county.data.map(e1=> {
                let obj1 = { id: e1.value, type: 'county',realName: e1.text };
                arr.push(obj1)
            })
            data.children = arr
        }

        if (canflash) {
            setTimeout(_=> {
                this.$refs.vtree2.setCheckedKeys(this.dataChecked1);
                loading.close();
            },1000)
        } else {
            loading.close();
        }
    }
    /**树节点改变 */
    public handleCheckChange(data, check) {
        //     this.isChecked = check;
        //     // console.log('check+++++++++++++++++' + check);
        //     // console.log('isCheck+++++++++++++++++' + this.checked);
    }
    public async handleCheckChange1(data, check) {
        console.log('data,check',data,check)
        // if (data.type) {
        //     const loading = this.$loading({
        //         lock: true,
        //         text: 'Loading...',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.7)',
        //     });
        //     let xx:any = {isDeleted:!check}
        //     if (data.type == 'area') {
        //         xx.province = data.id
        //     } else if (data.type == 'city') {
        //         xx.city = data.id
        //     } else if (data.type == 'county') {
        //         xx.dataPermission = data.id
        //     }
        //     let res = await yun.editArrivalAdrDataPermission(xx)
        //     loading.close();
        // }
    }
    public async currentDataChecked1(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
        this.dataChecked1 = checkedKeys.checkedKeys;
        console.log('checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys',checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys)
        if (checkedNodes.type) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let check = checkedKeys.checkedKeys.includes(checkedNodes.id)
            if (!check) {
                this.dataChecked1.splice(this.dataChecked1.findIndex(item => item === checkedNodes.id), 1)
            } else {
                this.dataChecked1.push(checkedNodes.id)
            }
            let xx:any = {isDeleted:!check, id:this.did }
            if (checkedNodes.type == 'area') {
                xx.province = checkedNodes.id
            } else if (checkedNodes.type == 'city') {
                xx.city = checkedNodes.id
            } else if (checkedNodes.type == 'county') {
                xx.dataPermission = checkedNodes.id
            }else if (checkedNodes.type == 'all') {
                xx.isChooseAll = true
            }
            let res = await yun.editArrivalAdrDataPermission(xx)
            loading.close();
        }

    }
    currentDataChecked(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
        this.permissionIdsArr = [...checkedKeys.checkedKeys];
        // console.log(' this.permissionIdsArr=====>', JSON.stringify(this.permissionIdsArr));
    }
    public dataChecked = [];
    public dataChecked1 = [];
    /**复选框被点击时触发：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象所包含的四个属性 */
    // currentDataChecked(data, nodes) {
    //     if (nodes.checkedKeys.includes(data.id)) {
    //         this.permissionIdsArr.push(data.id);
    //     } else {
    //         let checkedKeys = this.$refs.vtree1.getCheckedKeys();
    //         this.$refs.vtree1.setCheckedKeys(checkedKeys);
    //         this.permissionIdsArr = checkedKeys;
    //     }
    // }

    /**功能权限：配置选项 */
    public defaultProps = {
        label: 'name',
        children: 'childList',
    };
    /** 功能权限选中 */
    public checked = [];
    /**复选框被点击时触发：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象所包含的四个属性 */
    currentChecked(data, node) {
        // this.permissionIdsArr = [...nodes.checkedKeys];
        // console.log(' this.permissionIdsArr=====>', JSON.stringify(nodes.checkedKeys));
        // console.log('data------>', JSON.stringify(data));
        // console.log('nodes------>', node);
        //这个方法是勾选父级子级也默认勾选 取消子级不影响父级
        this.childNodesChange(node);
        // 这个方法是勾选子级默认把父级也勾选上
        this.parentNodesChange(node);
        this.checked = this.$refs.vtree.getCheckedNodes();
        // console.log('this.checked-------->', this.checked);
        this.permissionIdsArr = [];
        this.checked.forEach((item) => {
            this.permissionIdsArr.push(item.key);
        });
        // console.log('this.permissionIdsArr-------->', JSON.stringify(this.permissionIdsArr));
    }
    childNodesChange(node) {
        console.log(node.checked, node.childNodes);
        let len = node.childNodes.length;
        if (len > 0) {
            for (let i = 0; i < len; i++) {
                if (!node.checked) {
                    node.childNodes[i].checked = false;
                } else {
                    node.childNodes[i].checked = true;
                }
                this.childNodesChange(node.childNodes[i]);
            }
        }
    }
    parentNodesChange(node) {
        if (node.parent) {
            for (let key in node) {
                if (key == 'parent') {
                    node[key].checked = true;
                    this.parentNodesChange(node[key]);
                }
            }
        }
    }
    /** 功能权限编辑保存 */
    public saveTreeData() {
        this.loading = true;
        this.permissionIds = this.permissionIdsArr.join(',');
        if (this.pid == this.loginUserId) {
            this.isShowAd = null;
        }
        UserApi.UpdatePermissions({ id: this.pid, webMenus: this.permissionIds })
            .then(() => {
                this.$message({
                    showClose: true,
                    message: '提交成功',
                    type: 'success',
                });
                this.loading = false;
                this.dialogVisible = false;
                this.$emit('reload');
            })
            .catch((error) => {
                this.loading = false;
            });
    }
    /** 数据权限编辑保存 */
    public savePermission() {
        this.loading = true;
        console.log('this.permissionIdsArr', this.permissionIdsArr)
        try {
            this.permissionIds = this.permissionIdsArr.join(',');
            let reg = new RegExp('uData,', '');
            this.permissionIds = this.permissionIds.replace(reg, '');
            this.permissionIds = this.permissionIds.split(',');
        } catch (e) {
            this.permissionIds = ''
        }
            yun.editDataPermissions({ id: this.did, customerBaseDataPermissions: this.permissionIds })
            .then(() => {
                this.$message({
                    showClose: true,
                    message: '提交成功',
                    type: 'success',
                });
                this.loading = false;
                this.dataDialogVisible = false;
                this.$emit('reload');
            })
            .catch((error) => {
                this.loading = false;
            });
    }
}
